import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { GetServiceCaller, PostServiceCaller } from '../../services/serviceCaller';
import { API_URL } from '../../constants';
import { Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Select from 'react-select';
import CustomDatePicker from '../../components/Custom-Datepicker';
import moment from 'moment';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { updateNavbarHeading } from '../../constants/layout/store/filterSlice';
import { FaSpinner } from 'react-icons/fa';
import * as Yup from 'yup';

const EmployeeHistoryEdit = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate()

    useEffect(() => {
        dispatch(updateNavbarHeading("Edit Employee History"));
        fetchIndexData();
    }, []);

    useEffect(() => {
        if (id) {
            fetchShowAPi(id);
        }
    }, [id]);

    // Runs once when existing rows load (e.g. edit mode)
    useEffect(() => {
      if (formData?.employeeDetails?.length) {
        formData.employeeDetails.forEach((line, index) => {
          if (line.DepartmentID) {
            fetchSubDepartment(line.DepartmentID, index);
          }
        });
      }
    }, []);

    const initialFormData = {
        LineNo: "1",
        ShiftID: "",
        DepartmentID: "",
        SubDepartmentID: "",
        DesignationID: "",
        FromDate: "",
        ToDate: null,
        ImmediateSuperiorID: "",
        PracticeManager: null,
        BranchID: "",
        canBeDisabled: 0,
        canBeTodateDisabled: 0,
        isDelete: true
    };

    const [formData, setFormData] = useState([{ ...initialFormData }]);
    console.log("formData:::", formData);

    const [employeeHistory, setEmployeeHistory] = useState([]);
    const [errors, setErrors] = useState([]);
    const [employeeDetails, setEmployeeDetails] = useState({});
    const [branchOptions, setBranchOptions] = useState([]);
    const [shiftsOptions, setShiftsOptions] = useState([]);
    const [departmentOptions, setDepartmentOptions] = useState([]);
    const [subDepartmentOptions, setSubDepartmentOptions] = useState([]);
    const [subDepartmentOptionsMap, setSubDepartmentOptionsMap] = useState({});
    const [designationOptions, setDesignationOptions] = useState([]);
    const [immediateSuperiorOptions, setImmediateSuperiorOptions] = useState([]);
    const [pageLoading, setPageLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    // ✅ Compact heights and paddings optimized for tighter data density
    const tableSelectStyle = {
        menuPortal: base => ({ ...base, zIndex: 9999 }),
        menu: base => ({ ...base, zIndex: 9999 }),
        control: (provided) => ({
            ...provided,
            minHeight: '26px',
            height: '26px',
            fontSize: '11px', 
        }),
        valueContainer: (provided) => ({
            ...provided,
            height: '26px',
            padding: '0 4px'
        }),
        input: (provided) => ({
            ...provided,
            margin: '0px',
        }),
        indicatorsContainer: (provided) => ({
            ...provided,
            height: '26px',
        }),
    };


    const fetchShowAPi = async (id) => {
        setPageLoading(true);

        try {
            const response = await GetServiceCaller(`${API_URL}rujul/employee-data/${id}`);
            if (response?.status === 200) {
                setPageLoading(false);

                const EmpDetails = response?.data?.data?.contactDetails;
                const EmpHistory = response?.data?.data?.EmployeeHistory;
                setEmployeeHistory(EmpHistory);
                setEmployeeDetails(EmpDetails);

                if (EmpHistory && EmpHistory.length > 0) {
                    setFormData(EmpHistory.map((item, index) => ({
                        ...item,
                        canBeDisabled: 1,
                        ID: 1,
                        canBeTodateDisabled: index === EmpHistory.length - 1 ? 0 : 1,
                    })));
                    setErrors(Array(EmpHistory.length).fill({}));
                }


            }
        } catch (err) {
            console.error("Error Fetching Show API:", err);
            toast.error("Failed to load employee history");
        } finally {
            setPageLoading(false);

        }
    };

    const fetchIndexData = async () => {
        try {
            let response = await GetServiceCaller(`${API_URL}rujul/employee-data`);
            if (response?.status === 200) {
                setBranchOptions(response?.data?.data?.branches?.map(option => ({
                    label: option.text,
                    value: option.value,
                })) || []);

                setDepartmentOptions(response?.data?.data?.department?.map(option => ({
                    label: option.text,
                    value: option.value,
                })) || []);

                setSubDepartmentOptions(response?.data?.data?.sub_department?.map(option => ({
                    label: option.text,
                    value: option.value,
                })) || []);

                setDesignationOptions(response?.data?.data?.designation?.map(option => ({
                    label: option.text,
                    value: option.value,
                })) || []);

                setImmediateSuperiorOptions(response?.data?.data?.immediate_manager?.map(option => ({
                    label: option.text,
                    value: option.value,
                })) || []);

                setShiftsOptions(response?.data?.data?.shifts?.map(option => ({
                    label: option.text,
                    value: option.value,
                })) || []);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
            toast.error("Failed to load form options");
        } finally {
        }
    };

     const fetchSubDepartment = async (deptId, rowIndex) => {
        try {
          if (!deptId) return;
    
          const res = await GetServiceCaller(`${API_URL}sub-department/${deptId}`);
          const data = res.data.data;
    
          const formattedOptions = data
            .filter(item => item.ID !== null && item.Name !== null)
            .map((item) => ({
              value: String(item.ID),
              label: item.Name,
            }));
    
          // Store options keyed by row index
          setSubDepartmentOptionsMap(prev => ({
            ...prev,
            [rowIndex]: formattedOptions,
          }));
    
        } catch (error) {
          console.error(error);
        }
      };
    
      // Safe getter — always returns an array, never undefined/null
      const getSubDeptOptions = (index) => {
        const mapped = subDepartmentOptionsMap[index];
        if (Array.isArray(mapped)) return mapped;
        if (Array.isArray(subDepartmentOptions)) return subDepartmentOptions;
        return [];
      };

    const handleAddLine = async () => {
        const lastRowIndex = formData.length - 1;
        const lastRow = formData[lastRowIndex];
        const newRowIndex = lastRowIndex + 1;

        setSubDepartmentOptionsMap(prev => ({
            ...prev,
            [newRowIndex]: prev[lastRowIndex] || subDepartmentOptions || [],
        }));

        let hasError = false;
        if (
            !lastRow.ShiftID ||
            !lastRow.DepartmentID ||
            // !lastRow.SubDepartmentID ||
            !lastRow.DesignationID ||
            !lastRow.FromDate
        ) {
            hasError = true;
        }
        let newErrors = [...errors];

        if (!lastRow.ToDate) {
            newErrors[lastRowIndex] = { ...newErrors[lastRowIndex], ToDate: "To Date is required" }; 
            hasError = true;
        }

        if (hasError) {
            setErrors(newErrors);
            toast.error("Please fill in the current row before adding a new one.");
            return;
        }

        // ✅ If no error, add new row
        const newLineNo = formData.length + 1;
        setFormData(prev => [
            ...prev,
            {
                ...initialFormData,
                LineNo: newLineNo.toString(),
                ShiftID: lastRow?.ShiftID,
                DepartmentID: lastRow?.DepartmentID,
                SubDepartmentID: lastRow?.SubDepartmentID,
                DesignationID: lastRow?.DesignationID,
                FromDate: lastRow?.ToDate
                    ? moment(lastRow.ToDate).add(1, "days").format("YYYY-MM-DD")
                    : null,
                ToDate: null,
                ImmediateSuperiorID: lastRow?.ImmediateSuperiorID,
                PracticeManager: lastRow?.PracticeManager || null,
                BranchID: lastRow?.BranchID,
            }
        ]);
        setErrors(prev => [...prev, {}]); 
    };


    const deleteLine = (e, lineNo) => {
        e.preventDefault();
        const newFormData = formData.filter(item => item.LineNo !== lineNo);
        setFormData(newFormData);
        setErrors(errors.filter((_, index) => index !== lineNo - 1));
    };

    const schema = Yup.array().of(
        Yup.object().shape({
            BranchID: Yup.mixed().required("Branch is required"),
            ShiftID: Yup.mixed().required("Shift is required"),
            DepartmentID: Yup.mixed().required("Department is required"),
            SubDepartmentID: Yup.string().nullable(),
            DesignationID: Yup.mixed().required("Designation is required"),

            ImmediateSuperiorID: Yup.mixed().when("ID", {
                is: (val) => val != 1,
                then: (s) => s.required("Immediate Supervisor is required"),
                otherwise: (s) => s.nullable(),
            }),

            PracticeManager: Yup.mixed().when("ID", {
                is: (val) => val != 1,
                then: (s) => s.required("Practice Manager is required"),
                otherwise: (s) => s.nullable(),
            }),

            FromDate: Yup.string().required("From Date is required"),
            ToDate: Yup.string().nullable(),
        })
    );


    const validateField = async (index, fieldName) => {
        if (formData[index]?.canBeDisabled === 1) {
            setErrors(prevErrors => {
                const newErrors = [...prevErrors];
                if (newErrors[index]) {
                    delete newErrors[index][fieldName];
                }
                return newErrors;
            });
            return;
        }

        try {
            await schema.validateAt(`[${index}].valueField`, formData);
            setErrors(prevErrors => {
                const newErrors = [...prevErrors];
                if (newErrors[index]) {
                    delete newErrors[index][fieldName];
                }
                return newErrors;
            });
        } catch (err) {
            setErrors(prevErrors => {
                const newErrors = [...prevErrors];
                if (!newErrors[index]) newErrors[index] = {};
                newErrors[index][fieldName] = err.message;
                return newErrors;
            });

            if (err.message.includes("required")) {
                toast.error(err.message, { position: "top-right" });
            }
        }
    };

    const handleLineSelect = async (selectedOption, fieldName, index) => {
        const newFormData = [...formData];
        newFormData[index][fieldName] = selectedOption ? selectedOption.value : "";
        setFormData(newFormData);
        await validateField(index, fieldName);
    };

    const handleAllLineChange = async (e, index) => {
        const { name, value } = e.target;
        const newFormData = [...formData];
        newFormData[index][name] = value;
        setFormData(newFormData);
        await validateField(index, name);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        try {

            await schema.validate(formData, { abortEarly: false });
            setErrors([]);

            const payload = {
                employeeDetails: formData.map(item => ({
                    LineNo: item.LineNo,
                    BranchID: item.BranchID,
                    ShiftID: item.ShiftID,
                    DepartmentID: item.DepartmentID,
                    SubDepartmentID: item.SubDepartmentID,
                    DesignationID: item.DesignationID,
                    FromDate: item.FromDate,
                    ID: item?.ID || null,
                    ToDate: item.ToDate || null,
                    ImmediateSuperiorID: item.ImmediateSuperiorID,
                    PracticeManager: item.PracticeManager || null
                }))
            };
            const response = await PostServiceCaller(
                `${API_URL}employee-history-details/${id}`,
                payload,
                "put"
            );

            if (response?.status === 200) {
                toast.success("Data submitted successfully!");
                await fetchShowAPi(id);

                setTimeout(() => {
                    navigate("/employee/history")
                }, 2000)
            } else {
                throw new Error(response?.data?.message || "Failed to submit data");
            }
        } catch (error) {
            if (error instanceof Yup.ValidationError) {
                const newErrors = Array.from({ length: formData.length }, () => ({}));

                error.inner.forEach(err => {
                    const match = err.path?.match(/^\[(\d+)\]\.(.+)$/);
                    if (match) {
                        const index = parseInt(match[1]);
                        const fieldName = match[2];

                        if (formData[index]?.canBeDisabled !== 1) {
                            newErrors[index][fieldName] = err.message;
                        }
                    }
                });

                setErrors(newErrors);
            } else {
                console.error("API Error:", error);
                toast.error(
                    error.response?.data?.message ||
                    error.message ||
                    "An error occurred while submitting data"
                );
            }
        } finally {
            setIsSubmitting(false);
        }
    };


    const TooltipWrapper = ({ value, tooltipText, children }) => {
        const hasValue = value !== null && value !== undefined && value !== "";
        return hasValue ? (
            <OverlayTrigger
                placement="top"
                overlay={<Tooltip>{tooltipText}</Tooltip>}
            >
                <div>{children}</div>
            </OverlayTrigger>
        ) : (
            <div>{children}</div>
        );
    };

    if (pageLoading) {
        return (
            <div className="position-absolute top-50 start-50 translate-middle text-center">
                <FaSpinner className="spinner" />
            </div>
        );
    }

    return (
        <div className="Container ">
            {/* ✅ Using standard zoom property instead of CSS transform scales. This guarantees full-width expansion across 14-inch screens without leaving side blank spaces */}
            <style>{`
                @media (max-width: 1440px) {
                    .clean-zoom-wrapper {
                        zoom: 0.84;
                    }
                    .clean-zoom-wrapper th, .clean-zoom-wrapper td {
                        padding: 4px 3px !important;
                    }
                }
                @media (max-width: 1200px) {
                    .clean-zoom-wrapper {
                        zoom: 0.76;
                    }
                }
                /* Tweak nested datepickers to stay visually clean under high cell density layouts */
                .clean-zoom-wrapper input.form-control {
                    height: 26px !important;
                    font-size: 11px !important;
                    padding: 0 6px !important;
                }
            `}</style>

            <form
                id="formOne"
                className="rounded mt-2 bg-white"
                onSubmit={handleSubmit}
            >
                <div className="container-fluid">
                    <div className='row'>
                        <div className='col-md-3 col-sm-6 mb-2'>
                            <label className='form-label small fw-bold'> Name</label>
                            <input className='form-control form-control-sm' value={employeeDetails?.Name || ''} disabled />
                        </div>
                        <div className='col-md-3 col-sm-6 mb-2'>
                            <label className='form-label small fw-bold'> Designation</label>
                            <input className='form-control form-control-sm'
                                value={designationOptions?.find(o => o.value == employeeHistory?.[employeeHistory.length - 1]?.DesignationID)?.label || ''}
                                disabled
                            />
                        </div>
                        <div className='col-md-3 col-sm-6 mb-2'>
                            <label className='form-label small fw-bold'> Department</label>
                            <input className='form-control form-control-sm'
                                value={departmentOptions?.find(o => o.value == employeeHistory?.[employeeHistory.length - 1]?.DepartmentID)?.label || ''}
                                disabled
                            />
                        </div>
                        <div className='col-md-3 col-sm-6 mb-2'>
                            <label className='form-label small fw-bold'>Sub Department</label>
                            <input className='form-control form-control-sm'
                                value={subDepartmentOptions?.find(o => o.value == employeeHistory?.[employeeHistory.length - 1]?.SubDepartmentID)?.label || ''}
                                disabled
                            />
                        </div>
                        <div className='col-md-3 col-sm-6 mb-2'>
                            <label className='form-label small fw-bold'> Joining Date</label>
                            <input
                                className='form-control form-control-sm'
                                value={employeeDetails?.JoiningDate ? moment(employeeDetails.JoiningDate).format("DD-MMM-YYYY") : ''}
                                disabled
                            />
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="d-flex justify-content-between align-items-center mb-1">
                            <strong className="fs-6">Employee History</strong>
                            <button
                                type="button"
                                className="custom-btn btn-sm"
                                onClick={handleAddLine}
                            >
                                Add
                            </button>
                        </div>
                        <hr className="my-2" />
                        
                        {/* ✅ Table container using direct zoom adjustments to align neatly to both edges */}
                        <div className="clean-zoom-wrapper w-100">
                            <Table id="poctable_head" className="table table-bordered table-sm text-nowrap align-middle" style={{ marginBottom: 0, width: '100%' }}>
                                <thead
                                    id="thcolor"
                                    className="text-center align-middle"
                                    style={{ backgroundColor: "#fff", fontSize: '11px' }}
                                >
                                    <tr>
                                        <th style={{ width: "9%", background: "#fff" }}>Branch<span className="required">*</span></th>
                                        <th style={{ width: "9%", background: "#fff" }}>Shift<span className="required">*</span></th>
                                        <th style={{ width: "11%", background: "#fff" }}>Department<span className="required">*</span></th>
                                        <th style={{ width: "12%", background: "#fff" }}>Sub Department</th>
                                        <th style={{ width: "12%", background: "#fff" }}>Designation<span className="required">*</span></th>
                                        <th style={{ width: "13%", background: "#fff" }}>Immediate Supervisor<span className="required">*</span></th>
                                        <th style={{ width: "13%", background: "#fff" }}>Practice Manager<span className="required">*</span></th>
                                        <th style={{ width: "10%", background: "#fff" }}>From Date<span className="required">*</span></th>
                                        <th style={{ width: "10%", background: "#fff" }}>To Date</th>
                                        <th style={{ width: "4%", background: "#fff" }}>Delete</th>
                                    </tr>
                                </thead>
                                <tbody style={{ fontSize: '11px' }}>
                                    {formData.map((line, index) => (
                                        <tr key={index}>
                                            {/* Branch */}
                                            <td>
                                                <TooltipWrapper
                                                    value={line.BranchID}
                                                    tooltipText={
                                                        branchOptions.find(opt => opt.value === line.BranchID)?.label
                                                    }
                                                >
                                                    <Select
                                                        name="BranchID"
                                                        value={branchOptions.find(opt => opt.value == line.BranchID)}
                                                        menuPortalTarget={document.body}
                                                        styles={tableSelectStyle}
                                                        menuPlacement="auto"
                                                        className={errors[index]?.BranchID ? "is-invalid" : ""}
                                                        options={[{ value: "", label: "Select" }, ...branchOptions]}
                                                        isDisabled={line.canBeDisabled === 1}
                                                        onChange={selectedOption =>
                                                            handleLineSelect(selectedOption, "BranchID", index)
                                                        }
                                                    />
                                                </TooltipWrapper>
                                                {errors[index]?.BranchID && (
                                                    <div className="text-danger small mt-1">{errors[index].BranchID}</div>
                                                )}
                                            </td>

                                            {/* Shift */}
                                            <td>
                                                <TooltipWrapper
                                                    value={line.ShiftID}
                                                    tooltipText={
                                                        shiftsOptions.find(opt => opt.value === line.ShiftID)?.label
                                                    }
                                                >
                                                    <Select
                                                        name="ShiftID"
                                                        value={shiftsOptions.find(opt => opt.value === line.ShiftID)}
                                                        isDisabled={line.canBeDisabled === 1}
                                                        menuPortalTarget={document.body}
                                                        styles={tableSelectStyle}
                                                        menuPlacement="auto"
                                                        className={errors[index]?.ShiftID ? "is-invalid" : ""}
                                                        options={[{ value: "", label: "Select" }, ...shiftsOptions]}
                                                        onChange={selectedOption =>
                                                            handleLineSelect(selectedOption, "ShiftID", index)
                                                        }
                                                    />
                                                </TooltipWrapper>
                                                {errors[index]?.ShiftID && (
                                                    <div className="text-danger small mt-1">{errors[index].ShiftID}</div>
                                                )}
                                            </td>

                                            {/* Department */}
                                            <td>
                                                <TooltipWrapper
                                                    value={line.DepartmentID}
                                                    tooltipText={
                                                        departmentOptions.find(opt => opt.value === line.DepartmentID)?.label
                                                    }
                                                >
                                                    <Select
                                                        name="DepartmentID"
                                                        isDisabled={line.canBeDisabled === 1}
                                                        className={errors[index]?.DepartmentID ? "is-invalid" : ""}
                                                        value={departmentOptions.find(opt => opt.value === line.DepartmentID)}
                                                        onChange={(selectedOption) => {
                                                            handleLineSelect(selectedOption, "DepartmentID", index, "employeeDetails");

                                                            if (selectedOption?.value) {
                                                                fetchSubDepartment(selectedOption.value, index); //  pass index
                                                            } else {
                                                                // Clear sub-dept options for this row if dept is cleared
                                                                setSubDepartmentOptionsMap(prev => ({
                                                                    ...prev,
                                                                    [index]: [],
                                                                }));
                                                            }
                                                        }}
                                                        menuPortalTarget={document.body}
                                                        styles={tableSelectStyle}
                                                        menuPlacement="auto"
                                                        options={[{ value: "", label: "Select" }, ...departmentOptions]}
                                                    />
                                                </TooltipWrapper>
                                                {errors[index]?.DepartmentID && (
                                                    <div className="text-danger small">{errors[index].DepartmentID}</div>
                                                )}
                                            </td>

                                             {/* Sub Department */}
                                            <td>
                                                <TooltipWrapper
                                                    value={line.SubDepartmentID}
                                                    tooltipText={
                                                        subDepartmentOptions.find(opt => opt.value === line.SubDepartmentID)?.label
                                                    }
                                                >
                                                    <Select
                                                        name="SubDepartmentID"
                                                        isDisabled={line.canBeDisabled === 1}
                                                        className={errors[index]?.SubDepartmentID ? "is-invalid" : ""}
                                                        value={
                                                            getSubDeptOptions(index).find(
                                                                opt => String(opt.value) === String(line.SubDepartmentID)
                                                            ) || null
                                                        }
                                                        onChange={(selectedOption) =>
                                                            handleLineSelect(selectedOption, "SubDepartmentID", index, "employeeDetails")
                                                        }
                                                        menuPortalTarget={document.body}
                                                        styles={tableSelectStyle}
                                                        menuPlacement="auto"
                                                         options={[{ value: "", label: "Select" }, ...getSubDeptOptions(index)]}
                                                    />
                                                </TooltipWrapper>
                                                {errors[index]?.SubDepartmentID && (
                                                    <div className="text-danger small mt-1">{errors[index].SubDepartmentID}</div>
                                                )}
                                            </td>

                                            {/* Designation */}
                                            <td>
                                                <TooltipWrapper
                                                    value={line.DesignationID}
                                                    tooltipText={
                                                        designationOptions.find(opt => opt.value === line.DesignationID)?.label
                                                    }
                                                >
                                                    <Select
                                                        name="DesignationID"
                                                        isDisabled={line.canBeDisabled === 1}
                                                        className={errors[index]?.DesignationID ? "is-invalid" : ""}
                                                        value={designationOptions.find(opt => opt.value === line.DesignationID)}
                                                        menuPortalTarget={document.body}
                                                        styles={tableSelectStyle}
                                                        menuPlacement="auto"
                                                        options={[{ value: "", label: "Select" }, ...designationOptions]}
                                                        onChange={selectedOption =>
                                                            handleLineSelect(selectedOption, "DesignationID", index)
                                                        }
                                                    />
                                                </TooltipWrapper>
                                                {errors[index]?.DesignationID && (
                                                    <div className="text-danger small mt-1">{errors[index].DesignationID}</div>
                                                )}
                                            </td>

                                            {/* Immediate Supervisor */}
                                            <td>
                                                <TooltipWrapper
                                                    value={line.ImmediateSuperiorID}
                                                    tooltipText={
                                                        immediateSuperiorOptions.find(opt => opt.value === line.ImmediateSuperiorID)?.label
                                                    }
                                                >
                                                    <Select
                                                        isDisabled={line.canBeDisabled === 1}
                                                        name="ImmediateSuperiorID"
                                                        className={errors[index]?.ImmediateSuperiorID ? "is-invalid" : ""}
                                                        value={immediateSuperiorOptions.find(opt => opt.value === line.ImmediateSuperiorID)}
                                                        onChange={selectedOption =>
                                                            handleLineSelect(selectedOption, "ImmediateSuperiorID", index)
                                                        }
                                                        menuPortalTarget={document.body}
                                                        styles={tableSelectStyle}
                                                        menuPlacement="auto"
                                                        options={[{ value: "", label: "Select" }, ...immediateSuperiorOptions]}
                                                    />
                                                </TooltipWrapper>
                                                {errors[index]?.ImmediateSuperiorID && (
                                                    <div className="text-danger small mt-1">{errors[index].ImmediateSuperiorID}</div>
                                                )}
                                            </td>

                                            {/* Practice Manager */}
                                            <td>
                                                <TooltipWrapper
                                                    value={line.PracticeManager}
                                                    tooltipText={
                                                        immediateSuperiorOptions.find(opt => opt.value === line.PracticeManager)?.label
                                                    }
                                                >
                                                    <Select
                                                        isDisabled={formData?.length - 1 == index ? false : line.canBeDisabled === 1}
                                                        name="PracticeManager"
                                                        value={immediateSuperiorOptions.find(
                                                            opt => opt.value === line.PracticeManager
                                                        ) || null}
                                                        onChange={(selectedOption) =>
                                                            handleLineSelect(selectedOption, "PracticeManager", index)
                                                        }
                                                        className={errors[index]?.PracticeManager ? "is-invalid" : ""}
                                                        menuPortalTarget={document.body}
                                                        styles={tableSelectStyle}
                                                        menuPlacement="auto"
                                                        options={[{ value: "", label: "Select" }, ...immediateSuperiorOptions]}
                                                    />
                                                </TooltipWrapper>
                                                {errors[index]?.PracticeManager && (
                                                    <div className="text-danger small mt-1">{errors[index].PracticeManager}</div>
                                                )}
                                            </td>

                                            {/* From Date */}
                                            <td>
                                                <TooltipWrapper value={line.FromDate} tooltipText={line.FromDate}>
                                                    <div style={{ position: 'relative', zIndex: 1 }}>
                                                        <CustomDatePicker
                                                            required={true}
                                                            readOnly={line.canBeDisabled === 1}
                                                            handleChange={e => handleAllLineChange(e, index)}
                                                            minDate={(() => {
                                                                const prevToDate = formData[index - 1]?.ToDate;
                                                                return prevToDate && moment(prevToDate).isValid()
                                                                    ? moment(prevToDate).add(1, "days").toDate()
                                                                    : new Date();
                                                            })()}
                                                            name="FromDate"
                                                            value={line.FromDate}
                                                            className={errors[index]?.FromDate ? "is-invalid" : ""}
                                                            calendarContainer={(props) => <div {...props} style={{ zIndex: 9999 }} />}
                                                        />
                                                    </div>
                                                </TooltipWrapper>
                                                {errors[index]?.FromDate && (
                                                    <div className="text-danger small mt-1">{errors[index].FromDate}</div>
                                                )}
                                            </td>

                                            {/* To Date */}
                                            <td>
                                                <TooltipWrapper value={line.ToDate} tooltipText={line.ToDate}>
                                                    <div style={{ position: 'relative', zIndex: 1 }}>
                                                        <CustomDatePicker
                                                            readOnly={line.canBeTodateDisabled === 1}
                                                            handleChange={e => handleAllLineChange(e, index)}
                                                            minDate={moment().subtract(1, "months").endOf("month").toDate()}
                                                            name="ToDate"
                                                            className={errors[index]?.ToDate ? "is-invalid" : ""}
                                                            value={line.ToDate}
                                                            calendarContainer={(props) => <div {...props} style={{ zIndex: 9999 }} />}
                                                        />
                                                    </div>
                                                </TooltipWrapper>
                                                {errors[index]?.ToDate && (
                                                    <div className="text-danger small mt-1">{errors[index].ToDate}</div>
                                                )}
                                            </td>

                                            {/* Delete */}
                                            <td className="text-center align-middle">
                                                <a
                                                    onClick={
                                                        line.isDelete ? e => deleteLine(e, line.LineNo) : undefined
                                                    }
                                                    className={line.isDelete ? "text-danger" : "text-muted"}
                                                    style={{
                                                        pointerEvents: line.isDelete ? "auto" : "none",
                                                        cursor: line.isDelete ? "pointer" : "not-allowed"
                                                    }}
                                                >
                                                    <i
                                                        className={`bi bi-trash icons${line.isDelete ? "" : "disabled-icon"
                                                            }`}
                                                    ></i>
                                                </a>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>
                        <div className="text-end mt-3">
                            <button type="button" className="cancel-btn me-2" onClick={() => navigate('/employee/history')}>
                                Cancel
                            </button>
                            <button type="submit" className="custom-btn" disabled={isSubmitting}>
                                {isSubmitting ? <FaSpinner className='spinner-sm' /> : 'Submit'}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default EmployeeHistoryEdit;